<template>
    <div>
        <div class="tabs pt-8 mb-2">
            <button v-for="(tab, index) in tabs" :key="index" class="" :class=" { active: selectedIndex === index }"
                @click="selectTab(index)">
                {{ tab.name }}
            </button>
        </div>
        <!-- <hr /> -->
        <div class="tab-content">
            <component :is="selectedComponent"></component>
        </div>
    </div>
</template>
  
  <script>
 import AccountOwner from './modules/AccountOwner.vue';
 import AccountInformation from './modules/AccountInformation.vue';


  export default {
    components: {
        AccountOwner,
        AccountInformation,
    },
    data() {
        return {
            selectedIndex: 0,
            tabs: [
                { name: 'Account Owner', component: AccountOwner },
                { name: 'Account Information', component: AccountInformation },
            ],
        };
    },

    computed: {
        selectedComponent() {
            return this.tabs[this.selectedIndex].component;
        },
    },

    methods: {
        selectTab(index) {
            this.selectedIndex = index;
        },
    },

  };
  </script>
  
  <style>
  .tabs {
    display: flex;
    
    /* justify-content: center; */
    /* border: 1px solid green; */
  }
  .tabs button {
    padding: 0.5rem 1.5rem;
  font-size: 0.9rem;
    
    font-weight: 600;
    background: transparent;
    outline: none;
    cursor: pointer;
    border: none;
    /* border-radius: 1px; */
    /* box-shadow: 0px 0px 20px 2px #00000014; */
  }
  .tabs .active {
    font-weight: bold;
    /* border-bottom: 2px solid blue; */
    color: #FCC210;
    background: white;
    border-radius: 8px;
    box-shadow: 0px 4px 10px rgba(17, 21, 25, 0.1);
  }

  .tab-content {
    /* margin-top: 20px; */
  }
  </style>